import { html, render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import "./travel-data/CalendarButton";

customElements.define(
	"esc-price-filter-info-without-dates",
	class extends HTMLElement {
		connectedCallback() {
			const category = this.getAttribute("event-category");
			const template = html`<esc-impression-interaction-tracker
				class="price-filter-info-without-date message message--colored"
				content-name="${category} - Preis Filter"
				content-piece="Reisedaten-Hinweis"
				content-target="#"
			>
				<span class="fa fa-info bullit bullit--blue"></span>
				<div>
					<span class="price-filter-info-without-date__text">
						${translate("price_filter_info_without_date")}
					</span>
					<esc-calendar-button
						class="price-filter-info-without-date__link text-underline hidden-desktop hidden-cinema"
					>
						${translate("price_filter_info_without_date_link")}
					</esc-calendar-button>
				</div>
			</esc-impression-interaction-tracker>`;
			render(template, this);
		}
	},
);
